import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import AdminsIcon from "./icons/AdminsIcon"
import { IconCheckMarkAssets } from "../../../components";
import { getBullets } from "../../../util/contentful";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import css from './SectionWhyTeach.module.css';

const SectionWhyTeach = ({ currentState, content, currentSubject }) => {
  const items = content && getBullets(content, 'whyBullet');

  return (
    <div className={css.root}>
      {content ? (
        <>
          <div className={css.rootTitleHolder}>
            <h2 className={css.rootTitle}>
              {content.whyTitle}
            </h2>
          </div>

          <p className={css.rootDescription}>
            {content.whyDescription}
          </p>
          <div className={css.adminInfo}>
            <AdminsIcon className={css.adminInfoIcon} />

            <ul className={css.list}>
              {Array.from(Array(Object.keys(items).length / 2).keys()).map(i => (
                <li className={css.listItem}>
                  <div className={css.listItemTitle} key={`whyBullet${i + 1}Title`}>
                    <IconCheckMarkAssets />
                    {items[`whyBullet${i + 1}Title`]}
                  </div>
                  <p className={css.listItemDescription} key={`whyBullet${i + 1}Description`}>
                    {documentToReactComponents(items[`whyBullet${i + 1}Description`])}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <>
          <div className={css.rootTitleHolder}>
            <h2 className={css.rootTitle}>
              {currentState && !currentSubject ?
                <FormattedMessage id='SectionWhyTeach.whyTeachStateTitle' values={{state: currentState?.label}} /> :
                currentState && currentSubject ?
                <FormattedMessage id='SectionWhyTeach.whyTeachSubjectTitle' values={{state: currentState?.label, subject: currentSubject?.parent}} /> :
                <FormattedMessage id="SectionWhyTeach.whyTeachTitle"  />}
            </h2>
          </div>

          <p className={css.rootDescription}>
            <FormattedMessage id="SectionWhyTeach.whyTeachDescription" />
          </p>
          <div className={css.adminInfo}>
            <AdminsIcon className={css.adminInfoIcon} />

            <ul className={css.list}>
              <li className={css.listItem}>
                <div className={css.listItemTitle}>
                  <IconCheckMarkAssets />
                  <FormattedMessage id="SectionWhyTeach.whyTeachItemTitle1" />
                </div>
                <p className={css.listItemDescription}>
                  <FormattedMessage id="SectionWhyTeach.whyTeachItemDescription1" />
                </p>
              </li>
              <li className={css.listItem}>
                <div className={css.listItemTitle}>
                  <IconCheckMarkAssets />
                  <FormattedMessage id="SectionWhyTeach.whyTeachItemTitle2" />
                </div>
                <p className={css.listItemDescription}>
                  <FormattedMessage id="SectionWhyTeach.whyTeachItemDescription2" />
                </p>
              </li>
              <li className={css.listItem}>
                <div className={css.listItemTitle}>
                  <IconCheckMarkAssets />
                  <FormattedMessage id="SectionWhyTeach.whyTeachItemTitle3" />
                </div>
                <p className={css.listItemDescription}>
                  <FormattedMessage id="SectionWhyTeach.whyTeachItemDescription3" />
                </p>
              </li>
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default SectionWhyTeach;
